var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (user) {
jade_mixins["checkbox"] = jade_interp = function(name, disabled){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div class=\"settings-split artsy-checkbox\"><div class=\"settings-split__left\"><label" + (jade.attr("for", name, true, true)) + " class=\"artsy-checkbox--label js-settings-checkbox-label\">");
block && block();
buf.push("</label></div><div class=\"settings-split__right\"><div class=\"artsy-checkbox--checkbox\"><input type=\"checkbox\"" + (jade.attr("id", name, true, true)) + (jade.attr("name", name, true, true)) + (jade.attr("checked", user && user.isChecked(name), true, true)) + (jade.attr("disabled", disabled, true, true)) + "><label" + (jade.attr("for", name, true, true)) + "></label></div></div></div>");
};
buf.push("<form class=\"stacked-form\">");
jade_mixins["checkbox"].call({
block: function(){
buf.push("Receive Emails");
}
}, 'receive_emails');
buf.push("<div class=\"settings-email-preferences__subscriptions js-settings-email-preferences__subscriptions\">");
var disable = !user.get('receive_emails');
jade_mixins["checkbox"].call({
block: function(){
buf.push("What's on Artsy This Week");
}
}, 'receive_weekly_email', disable);
jade_mixins["checkbox"].call({
block: function(){
buf.push("Art World News");
}
}, 'receive_editorial_email', disable);
jade_mixins["checkbox"].call({
block: function(){
buf.push("Auctions");
}
}, 'receive_auction_email', disable);
jade_mixins["checkbox"].call({
block: function(){
buf.push("Personalized Art Recommendations");
}
}, 'receive_personalized_email', disable);
jade_mixins["checkbox"].call({
block: function(){
buf.push("Artsy Specialist Recommendations");
}
}, 'receive_offer_emails', disable);
buf.push("</div><button class=\"avant-garde-button-white\">Save Changes</button></form>");}.call(this,"user" in locals_for_with?locals_for_with.user:typeof user!=="undefined"?user:undefined));;return buf.join("");
};
module.exports = template;